var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Note = function Note(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h7.016a.998.998 0 0 0 .719-.322L19.936 14H20a1 1 0 0 0 1-1V6a3 3 0 0 0-3-3H6Zm11.207 11H14v3.453L17.207 14ZM5.293 5.293A1 1 0 0 1 6 5h12a1 1 0 0 1 1 1v6h-5a2 2 0 0 0-2 2v5H6a1 1 0 0 1-1-1V6a1 1 0 0 1 .293-.707Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Note;